import type { FaireProductEntity } from "../../entity_types/product";

export const p_s9evtgex34: FaireProductEntity = {
  token: "p_s9evtgex34",
  type: "product",
  name: "Everfresh Apple 12/16OZ",
  brandToken: "b_ktcqb4hfg7",
  brandName: "L&F Universal Goods",
  imageUrl:
    "https://cdn.faire.com/fastly/a17f5239b81b58bb1703a215c9c2ab1983112f6eefbae5d84c3e9795a2f06b36.png",
  galleryImageUrls: [],
  priceDollars: 29.1,
  description:
    "Pure apple juice beverage offering classic fruit taste, ideal for family purchases and consistent inventory turnover.",
  tags: [],
  msrpDollars: 56.81,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:21.796Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
